<template>
  <Breadcrumb :home="home" :model="items" class="bread" />
</template>

<script>
export default {
    data() { 
        return {
            home: {label: 'Home', to: '/'},
            /* items: [
                {label: 'Computer', to: '/servicios'},
                {label: 'Notebook'},
                {label: 'Accessories'},
                {label: 'Backpacks'},
                {label: 'Item'}
            ] */
        }
    },
    computed: {
        items() {
            if(!this.$route.meta.bread){
                return []
            }else{
                const bread = this.$route.meta.bread.map((item) => {
                    return {
                        label: this.$t(item.label),
                        to: item.to
                    }
                })
                return bread;
            }
        }
    },
}
</script>

